export default class SelectType {
    constructor(element, parent) {
        this.parent = parent;
        this.element = element;
        this.select = element.querySelector('select');
        this.type = this.select?.dataset.type;
    }

    init() {
        if (!this.select) {
            return;
        }

        this.select.addEventListener('click', (event) => {
            event.target.classList.toggle('active');
        });

        this.select.addEventListener('focusout', (event) => {
            event.target.classList.remove('active');
        });

        this.select.addEventListener('change', (event) => {
            this.setFilterArgs();

            if (!this.parent.hasApplyButton) {
                this.parent.sendFiltersChange(event.target);
            }

            event.target.blur();
        });

        this.updateInitialValue();
    }

    setFilterArgs() {
        let taxonomySlug = null;
        switch (this.type) {
            case 'taxonomy':
                taxonomySlug = this.select.dataset.taxonomy || null;

                this.setTaxonomy(taxonomySlug, this.selectedOptions);
                break;
            case 'content_type':
                this.setContentType(this.selectedOptions);
                break;
            case 'sort_by':
                this.setOrderBy(this.selectedOptions);
                break;
            case 'date_range':
                this.setDateRange(this.selectedOptions);
                break;
            default:
        }
    }

    updateInitialValue() {
        // Check if exist filter args for this type
        if (!this.hasFilterArgs()) {
            return;
        }

        let slug;

        // Sort by has 2 parts: order and order by
        if (this.type === 'sort_by') {
            const orderParams = this.getFilterArgs();

            slug = orderParams.join('_');
        } else {
            slug = this.getFilterArgs();
        }

        const selectedOption = [...this.select.options].find((option) => option.dataset.slug === slug);

        this.select.value = selectedOption.value;
    }

    hasFilterArgs() {
        if (this.type === 'taxonomy') {
            const taxonomySlug = this.select.dataset.taxonomy || null;

            if (
                !this.parent.filterArgs.taxonomy ||
                !Object.keys(this.parent.filterArgs.taxonomy).length ||
                !this.parent.filterArgs.taxonomy[taxonomySlug] ||
                !this.parent.filterArgs.taxonomy[taxonomySlug].length
            ) {
                return false;
            }
        }

        if (this.type === 'content_type' && !this.parent.filterArgs.content_type?.length) {
            return false;
        }

        if (this.type === 'sort_by' && (!this.parent.filterArgs?.order_by || !this.parent.filterArgs?.order)) {
            return false;
        }

        if (this.type === 'date_range' && !this.parent.filterArgs?.date_range_type) {
            return false;
        }

        return true;
    }

    getFilterArgs() {
        if (this.type === 'taxonomy') {
            const taxonomySlug = this.select.dataset.taxonomy || null;

            return this.parent.filterArgs.taxonomy[taxonomySlug][0];
        }

        if (this.type === 'content_type') {
            return this.parent.filterArgs.content_type[0];
        }

        if (this.type === 'sort_by') {
            return [this.parent.filterArgs.order_by, this.parent.filterArgs.order];
        }

        if (this.type === 'date_range') {
            return this.parent.filterArgs.date_range_type;
        }

        return false;
    }

    setDateRange(options) {
        // eslint-disable-next-line prefer-destructuring
        this.parent.filterArgs.date_range_type = options[0];
    }

    setOrderBy(options) {
        const [orderBy, order] = options[0].split('_');

        this.parent.filterArgs.order_by = orderBy;
        this.parent.filterArgs.order = order;
    }

    setContentType(options) {
        this.parent.filterArgs.content_type = options;
    }

    setTaxonomy(slug, options) {
        if (!this.parent.filterArgs.taxonomy) {
            this.parent.filterArgs.taxonomy = {};
        }

        if (options.length) {
            this.parent.filterArgs.taxonomy[slug] = options;
        } else {
            delete this.parent.filterArgs.taxonomy[slug];
        }
    }

    get selectedOptions() {
        return [...this.select.options]
            .filter((option) => !option.disabled && option.selected && option.value !== 'all' && option.dataset.slug)
            .map((option) => option.dataset.slug);
    }

    clear() {
        this.select.selectedIndex = 0;
    }
}
